import {call, put, takeLatest} from 'redux-saga/effects';
import TaxProfile from '../api/TaxProfileApi';
import taxActions from '../actions/tax.actions';
import {handleSagaError} from './utils/CommonUtils';

function* refreshTaxRecord(action) {
    try {
        const record = yield call(TaxProfile.refreshTaxRecord, action.payload);
        yield put(taxActions.refreshTaxRecordComplete(record));
    } catch (e) {
        yield handleSagaError(e, taxActions.refreshTaxRecordFailed(e));
    }
}

function* fetchOrganizations(action) {
    try {
        const organizations = yield call(TaxProfile.getOrganizations, action.payload);
        yield put(taxActions.getOrganizationsSuccess(organizations));
    } catch (e) {
        yield handleSagaError(e, taxActions.getOrganizationsFailed(e));
    }
}

function* consentForPayment(action) {
    try {
        const consentUrl = yield call(TaxProfile.consentForPayment, action.payload);
        yield put(taxActions.consentForPaymentSuccess(consentUrl));
    } catch (e) {
        yield handleSagaError(e, taxActions.consentForPaymentFailed(e));
    }
}

function* fetchTaxInterviewURL(action) {
    try {
        const taxInterview = yield call(TaxProfile.getTaxInterviewURL, action.payload);
        yield put(taxActions.getTaxInterviewURLSuccess(taxInterview));
    } catch (e) {
        yield handleSagaError(e, taxActions.getTaxInterviewURLFailed(e));
    }
}

function* fetchTaxRecord(action) {
    try {
        const response = yield call(TaxProfile.getTaxRecord, action.payload);
        const _rec = response.data;

        if (_rec && _rec.profileType) {
            const params = {
                profileType: _rec.profileType
            };

            if (_rec.organizationEntity) {
                Object.assign(params, {organizationId: _rec.identityId});
            }

            const available = yield call(TaxProfile.getUpdateAvailable, params);
            yield put(taxActions.getUpdateAvailableSuccess(available));
        }

        yield put(taxActions.getTaxRecordSuccess(response));
    } catch (e) {
        yield handleSagaError(e, taxActions.getTaxRecordFailed(e));
    }
}

function* retakeInterview(action) {
    try {
        const taxRecord = yield call(TaxProfile.retakeInterview, action.payload);
        yield put(taxActions.retakeInterviewSuccess(taxRecord));
    } catch (e) {
        yield handleSagaError(e, taxActions.retakeInterviewFailed(e));
    }
}

function* updateTaxRecord(action) {
    try {
        const taxRecord = yield call(TaxProfile.updateTaxRecord, action.payload);
        yield put(taxActions.updateTaxRecordSuccess(taxRecord));
    } catch (e) {
        yield handleSagaError(e, taxActions.updateTaxRecordFailed(e));
    }
}

function* getBalancePayable(action) {
    try {
        const payAble = yield call(TaxProfile.getBalancePayable, action.payload);
        yield put(taxActions.getBalancePayableSuccess(payAble));
    } catch (e) {
        yield handleSagaError(e, taxActions.getBalancePayableFailed(e));
    }
}

function* getConsent(action) {
    try {
        const resp = yield call(TaxProfile.getConsent, action.payload);
        yield put(taxActions.getConsentSuccess(resp));
    } catch (e) {
        yield handleSagaError(e, taxActions.getConsentFailed(e));
    }
}

function* getRecordEmail(action) {
    try {
        const resp = yield call(TaxProfile.getRecordEmail, action.payload);
        yield put(taxActions.getRecordEmailSuccess(resp));
    } catch (e) {
        yield handleSagaError(e, taxActions.getRecordEmailFailed(e));
    }
}

function* getAccountStatus(action) {
    try {
        const resp = yield call(TaxProfile.getAccountStatus, action.payload);
        yield put(taxActions.getAccountStatusSuccess(resp));
    } catch (e) {
        yield handleSagaError(e, taxActions.getAccountStatusFailed(e));
    }
}

function* getTaxStatus(action) {
    try {
        const resp = yield call(TaxProfile.getTaxStatus, action.payload);
        yield put(taxActions.getTaxStatusSuccess(resp));
    } catch (e) {
        yield handleSagaError(e, taxActions.getTaxStatusFailed(e));
    }
}

function* getHyperWalletActiveLink(action) {
    try {
        const resp = yield call(TaxProfile.getHyperWalletActiveLink, action.payload);
        yield put(taxActions.getHyperWalletActiveLinkSuccess(resp));
    } catch (e) {
        yield handleSagaError(e, taxActions.getHyperWalletActiveLinkFailed(e));
    }
}

function* taxSaga() {
    yield takeLatest(taxActions.TYPES.GET_BALANCE_PAYABLE, getBalancePayable);
    yield takeLatest(taxActions.TYPES.GET_ORGANIZATIONS, fetchOrganizations);
    yield takeLatest(taxActions.TYPES.GET_TAX_INTERVIEW, fetchTaxInterviewURL);
    yield takeLatest(taxActions.TYPES.GET_TAX_RECORD, fetchTaxRecord);
    yield takeLatest(taxActions.TYPES.RETAKE_INTERVIEW, retakeInterview);
    yield takeLatest(taxActions.TYPES.UPDATE_TAX_RECORD, updateTaxRecord);
    yield takeLatest(taxActions.TYPES.GET_CONSENT, getConsent);
    yield takeLatest(taxActions.TYPES.GET_RECORD_EMAIL, getRecordEmail);
    yield takeLatest(taxActions.TYPES.REFRESH_TAX_RECORD, refreshTaxRecord);
    yield takeLatest(taxActions.TYPES.CONSENT_FOR_PAYMENT, consentForPayment);
    yield takeLatest(taxActions.TYPES.GET_PAYOUT_ACCOUNT_STATUS, getAccountStatus);
    yield takeLatest(taxActions.TYPES.GET_TAX_STATUS, getTaxStatus);
    yield takeLatest(taxActions.TYPES.GET_HYPERWALLET_ACTIVE_LINK, getHyperWalletActiveLink);
}

export default taxSaga;
